import React, { Component } from 'react';


// functions
import { scrollUp } from '../functions/functions'
// Images
import Century from "../../assets/img/CenturyHeb.png";
import Vi from "../../assets/video/About.mp4";
import { isMobile } from 'react-device-detect';
// Animations
import { Animated } from "react-animated-css";
import Img1927 from "../../assets/img/1972.jpg";
import Img1975 from "../../assets/img/1975.jpg";
import Img1990 from "../../assets/img/1990New.jpg";
import Img2009 from "../../assets/img/2009New.jpg";
import Img2019 from "../../assets/img/2019.jpg";
import Img2025 from "../../assets/img/2025.jpg";


// import {Parallax} from 'react-scroll-parallax';

class About extends Component {

    async componentDidMount() {
        this.props.changeScrollState(false, 'about')
        await scrollUp()
        await this.scrollEvent()
    }
    componentWillReceiveProps(nextProps) {
        console.log("scroll2", nextProps)
    }

    scrollEvent() {
        console.log("scroll", this.props.state.menuScrolled)
        if (!this.props.state.menuScrolled && window.pageYOffset === 0) {
            window.addEventListener('scroll', this.chageParentSate)
        }
    }

    chageParentSate = () => {
        console.log("34")
        if (window.pageYOffset !== 0) {
            this.props.changeScrollState(true, 'about')
            window.removeEventListener('scroll', this.chageParentSate)
        }

    }
    componentWillUnmount() {
        console.log("unmount")
        this.props.changeScrollState(false, 'about')
    }







    render() {
        console.log("props", this.props.state)
        return (
            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>

                <div className="PageHolder">
                    <div className="ContentHolder07">
                        {
                            !isMobile &&
                            <video className="Video01" loop={true} autoPlay>
                                <source src={Vi} type="video/mp4" />
                            </video>
                        }
                        <div className="OnVideo">
                            <div className="ImageHolder05">
                                <img src={Century} alt="" className="Image02" />

                            </div>
                            <div className="ProductsAndServiceConatainer">
                                <div className="ServicesHolder">
                                    <div className="ImageHolder07">
                                        <img src={Img1927} className="Image03" alt="" />
                                    </div>
                                    <div className="ContentHolder03">
                                        <h2 className="titleGrey">1927</h2>
                                        <p className="rtlText">
                                            1927 – חברת עקיבא טולוצ'נסקי הוקמה ב-1927 ע"י מר טולוצ'ינסקי.
                                            פעילותה של החברה החלה בתקופת המנדט הבריטי, ותרמה את חלקה הצנוע בבניין הארץ, כחברה קבלנית לעבודות חשמל בתעשייה הרוקמת עור וגידים, הקמת מתקני חשמל שונים, תחנות שאיבה, תחנות השנאה, תכנון וייצור מכונות ייעודיות ולוחות פיקוד בקרה.
                                        </p>
                                    </div>
                                </div>
                                <div className="ProductsHolder">
                                    <div className="ContentHolder04">
                                        <h2 className="titleGrey">1975</h2>
                                        <p className="rtlText">החברה עברה לניהול הדור השני של המשפחה במיקומה בחיפה, בשנים אלו, הורחבה פעילות הייצור במגוון מוצרים בתחומים שונים ומגוונים-
                                            מתכת בטכנולוגיות כבישה קרה וחמה, עיבוד שבבי, כיפוף וניקוב, ציפוי pvc, ריתוך צנרת בלחץ גבוה וריתוך אלקטרודות. בד בבד, החברה פיתחה את תחום הפלסטיק והחלה בייצור מוצרים בטכנולוגיות אקסטרוזיה והזרקה.  </p>
                                    </div>
                                    <div className="ImageHolder06">
                                        <img src={Img1975} className="Image03" alt="" />
                                    </div>

                                </div>

                                <div className="ServicesHolder">
                                    <div className="ImageHolder07">
                                        <img src={Img1990} className="Image03" alt="" />
                                    </div>
                                    <div className="ContentHolder03">
                                        <h2 className="titleGrey">1990</h2>
                                        <p className="rtlText">
                                            בתחילת שנות ה-90 החברה נרשמה כחברת עקיבא טולוצ'ינסקי קבלנים לעבודות חשמל בע"מ,
                                            הדור השלישי של המשפחה הצטרף לניהול בחסות ניסיונו ונוכחותו של הדור השני.
                                            החברה הרחיבה את פעילויותיה והחלה לייצר מגוון אבזרי חשמל לפי תקנים בינלאומיים שונים, וכמו כן, החלה את התמחותה בייצור מוטות הארקה לפי התקן ההולנדי המחמיר KEMA.
                                            בשנת 1996 אושרה החברה ע"י מכון התקנים הישראלי ל- 9001 ISO.
                                        </p>
                                    </div>
                                </div>
                                <div className="ProductsHolder">
                                    <div className="ContentHolder04">
                                        <h2 className="titleGrey">2009</h2>
                                        <p className="rtlText">
                                            בשנה זו, החלה בהשתלבות בחברה הדור הרביעי למשפחת טולוצ'ינסקי והמפעל עבר מחיפה לאזור התעשייה בכרמיאל אשר בגליל.
                                            המבנה החדש אפשר הרחבה ושיפור קווי ייצור קיימים ומתן תפוקת ייצור המתאימה לביקוש שהאמיר במרוצת השנים עם הכנסת טכנולוגיות חדישות בתחומי ההלחמה האולטרסונים.
                                        </p>
                                    </div>
                                    <div className="ImageHolder06">
                                        <img src={Img2009} className="Image03" alt="" />
                                    </div>

                                </div>
                                <div className="ServicesHolder">
                                    <div className="ImageHolder07">
                                        <img src={Img2019} className="Image03" alt="" />
                                    </div>
                                    <div className="ContentHolder03">
                                        <h2 className="titleGrey">2021</h2>
                                        <p className="rtlText">
                                            בשנים אלו, עוסקת החברה בתכנון, פיתוח, ייצור ושיווק של מוצרי פלסטיק ומתכת והשילובים שלהם, ובאחזקת תווי תקן מחמירים למוצריה. החברה דוגלת ברמת איכות הגבוהה ביותר במוצריה ובמוצרים שמייצרת בקבלנות משנה ומקיימת קשרי סחר ענפים עם החברות הגדולות במשק הקשורות לענף החשמל וכמו כן עם מספר רב של לקוחות וספקים מרחבי העולם.
                                        </p>
                                    </div>
                                </div>
                                <div className="ProductsHolder">
                                    <div className="ContentHolder04">
                                        <h2 className="titleGrey">2025</h2>
                                        <p className="rtlText">
                                            מעבר להיסטוריה המכובדת והמרשימה שלה, חברת עקיבא טולוצ'ינסקי היא בעלת חזון ברור ומגובש, המצעיד אותה בבטחה היישר לקראת עידן תעשייה 4.0.
                                            החזון שלנו הוא פשוט למדי, אבל יחד עם זאת, יוצא דופן בייחודו - אנחנו מאמינים כי מקצועיות וחדשנות תעשייתית אינן יכולות להתקיים אך ורק בזכות עצמן, אם הן אינן מלוות ביתרון משמעותי נוסף – יתרון ההון האנושי.
                                            זו הייתה דרכנו מאז ומעולם, וזו תמשיך להיות הדרך היחידה בה נמשיך לעשות עסקים עם לקוחותינו, ספקינו ושותפינו העסקיים!
                                        </p>
                                    </div>
                                    <div className="ImageHolder06">
                                        <img src={Img2025} className="Image03" alt="" />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </Animated>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/About.js